import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectPersonValue } from 'services/people/selectors';

import { AppState } from 'services/types';

interface OwnProps {
    personId: number;
}

interface ConnectedProps {
    datacomId?: string;
}

type Props = OwnProps & ConnectedProps;

export class PersonDatacomId extends React.PureComponent<Props> {
    render() {
        const { datacomId } = this.props;
        if (!datacomId) return null;
        return datacomId;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    datacomId: makeSelectPersonValue('datacomId')
});

export default connect(mapStateToProps)(PersonDatacomId);
